export default __webpack_public_path__ + "static/media/Asset-7.04b99fd5.png";